module.exports = __webpack_public_path__ + "static/media/kehaline.08d1f9bc.jpg";